import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const GoogleCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const redirectUri = window.location.origin + "/auth/google";

    const run = async () => {
      if (!code) { navigate("/", { replace: true }); return; }
      try {
        const res = await fetch(`${API}/auth/google`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ code, redirect_uri: redirectUri }),
        });
        if (!res.ok) throw new Error("auth failed");
        const data = await res.json();
        setUser(data);
        // First sign-in: merge any guest layout + journal into this account.
        try {
          const clientId = localStorage.getItem("ws_client_id");
          if (clientId) {
            await fetch(`${API}/merge-guest`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "include",
              body: JSON.stringify({ client_id: clientId }),
            });
          }
        } catch (_) { /* non-blocking */ }
        window.history.replaceState(null, "", window.location.origin + "/");
        navigate("/", { replace: true });
      } catch (e) {
        setError(true);
        setTimeout(() => navigate("/", { replace: true }), 2200);
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="ws-live-dot mx-auto mb-4" />
        <p className="text-[color:var(--ws-muted)] text-sm">
          {error ? "Sign-in failed. Redirecting…" : "Signing you in…"}
        </p>
      </div>
    </div>
  );
};

export default GoogleCallback;
